<template>
  <div id="removeclass">
    <app-modal
      :modal-id="modalId"
      :modal-alignment="modal_alignment"
      :modal-size="modal_size"
      @close-modal="closeModal"
      style="background:rgba(0, 0, 0, .5)"
    >
      <template slot="header">
        <h4>{{modalTitle}}</h4>
      </template>
      <app-overlay-loader v-if="preloader" />
      <template slot="body">
        <div v-if="type == 'endorsement'">
          <div class="form-group row align-items-center">
            <label for="inputs_email" class="col-sm-3 mb-0">
              {{ $t("date") }}
            </label>
            <app-input
              id="amount"
              class="col-sm-9"
              type="date"
              v-model="inputs.endorse_date"
            />
          </div>
          <VueSignaturePad
            id="signature"
            width="100%"
            height="150px"
            ref="signaturePad"
            :options="{onBegin: () => {$refs.signaturePad.resizeCanvas()}}"
          />
          <p class="text-danger" v-if="show == true">{{message}}</p>
        </div>
        <div v-else>
          <table class="table">
            <thead class="thead-dark">
              <tr>
                <th>User Name</th>
                <th>Signature</th>
              </tr>
            </thead>
            <tbody v-if="list.length > 0">
              <tr v-for="(user,index) in list" :key="index">
                <td width="60%">
                  <h5 class="mb-1 mt-3" style="font-size: 1.15rem">
                    {{ user.user.full_name }}
                  </h5>
                  <p class="mb-2 text-muted font-size-90">{{ user.user.email }}</p>
                  <p class="text-muted font-size-90">Request Date: {{ getDateTimeFormatForBackend(user.created_at) }} </p>
                  <span v-if="user.status == 1" :class="'badge badge-sm badge-pill badge-success'">Endorsed</span>
                  <span v-else :class="'badge badge-sm badge-pill badge-warning'">Pending</span>
                </td>
                <td width="40%">
                  <app-avatar v-if="user.signature == null" :title="user.user.full_name" avatar-class="avatars-w-50 text-center"
                                  :alt-text="$t('not_found')"/>
                  <div class="text-center">
                    <img v-if="user.signature != null" :src="user.signature" :alt="$t('not_found')" class="img-fluid img-thumbnail">

                    <div v-if="inputIndex != index"
                      :key="'with-link-'+index"
                      class="d-flex align-items-center justify-content-between mb-0">
                      <p v-if="user.status == 1" class="mb-2 text-muted font-size-90">Endorsed At: {{user.endorse_date}}</p>
                      <div class="btn-group btn-group-action" v-if="user.status == 1">
                        <button
                          type="button"
                          class="btn"
                          data-toggle="tooltip"
                          data-placement="top"
                          :title="$t('edit')"
                          @click.prevent="edit(index)"
                          >
                          <app-icon name="edit"/>
                        </button>
                      </div>
                    </div>
                    <div v-else
                          class="h-100">
                      <div v-if="inputIndex == index" class="d-flex align-items-center h-100">
                          <app-input :id="'endorse_date-' + index"
                            class="mr-2 flex-grow-1"
                            type="date"
                            placeholder="Select Date"
                            v-model="endorse_date"/>
                          <button type="submit"
                            class="btn btn-sm btn-primary mr-2"
                            @click.prevent="editEndorseDate(user.id)">
                            {{ $t('save') }}
                          </button>
                          <a href="#" class="text-muted" @click.prevent="editToggle">
                              <app-icon name="x"/>
                          </a>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
            
          </table>
        </div>        
      </template>
      <template slot="footer">
        <button v-if="type == 'endorsement'" @click.prevent="undo" class="btn btn-danger mr-2" >Undo</button>
        <button v-if="type == 'endorsement'" @click.prevent="save" class="btn btn-success" >Save</button>
        <button v-if="type == 'view_endorsement'" @click.prevent="close" class="btn btn-primary mr-2" >Close</button>
      </template>
    </app-modal>
  </div>
</template>
<script>
import { FormMixin } from "../../../../../../../core/mixins/form/FormMixin.js";
import { ModalMixin } from "../../../../../../Mixins/ModalMixin";
import * as actions from "../../../../../../Config/ApiUrl";
import { axiosPost, axiosGet } from "../../../../../../Helpers/AxiosHelper.js";
import AppLibrary from "../../../../../../Helpers/AppLibrary";

export default {
  name: "AddModal",
  extends: AppLibrary,
  mixins: [FormMixin, ModalMixin],
  props: {
    endorseData: Object,
    refresh: Function,
    type: String,
  },
  data() {
    return {
      endorse_date:'',
      inputIndex: null,
      modal_alignment: 'center',
      modal_size: 'md',
      list: [],
      message: '',
      show: false,
      addurl: actions.TASK_ENDORSEMENT,
      preloader: false,
      modalId: "task-endorse-Modal",
      modalTitle: this.$t("document_endorsement"),
      inputs: {
        endorse_date: new Date(),
      },
    };
  },
  created() {
    if (this.type == 'view_endorsement' ) {
        this.modal_alignment = 'top';
        this.modal_size = 'large';
        this.getEndorsement();
    }
  },
  methods: {
    edit(index) {
      this.inputIndex = index;
    }, 
    editToggle() {
      this.inputIndex = null;
    },
    editEndorseDate(id) {
      let date = this.getDateFormatForBackend(this.endorse_date);
      this.inputs.endorse_date = date;
      this.inputs.id = id;
      axiosPost(actions.SITE_DOCUMENT_ENDORSE_DATE_UPDATE, this.inputs)
        .then((res) => {
          this.$toastr.s(res.data.message);
          this.getEndorsement();
          this.inputIndex = null;

        })
        .catch((error) => {
          console.error(error);
        });
    },
    undo() {
      this.$refs.signaturePad.undoSignature();
    },
    // save() {
    //   const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
    //   // console.log(file);
    //   console.log(data);
    // },
    save() {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();

      if (isEmpty == true) {
          this.message = 'Signature is required';
          this.show = true;
      }
      else {
        this.inputs.signature = data;
        this.inputs.site_id = this.endorseData.site_id;
        this.inputs.form_revision_id = this.endorseData.form_revision_id;
        axiosPost(actions.SITE_DOCUMENT_ENDORSE, this.inputs)
          .then((res) => {
            this.$toastr.s(res.data.message);
            this.close();
            this.refresh();
          })
          .catch((error) => {
            console.error(error);
          });
      }
      // this.save(this.inputs);
    },
    close() {
      $("#"+ this.modalId).modal("hide");
    },
    getEndorsement() {
      let site_id = this.endorseData.site_id;
      let form_revision_id = this.endorseData.form_revision_id;
      axiosGet(actions.SITE_DOCUMENT_ENDORSE_PROGRESS +'/'+ site_id+'?form_revision_id='+form_revision_id)
          .then((res) => {
            this.list = res.data.list;
          })
          .catch((error) => {
            console.error(error);
          });
    }
  },
  computed: {
    userRole() {
      return this.$store.state.user.loggedInUser;
    },
  },
  mounted() {
    if (this.type == 'endorsement' ) {
      $("#removeclass .modal-dialog ").removeClass("modal-dialog-scrollable");
    }
  },
};
</script>
<style>
#signature {
  border: double 3px transparent;
  border-radius: 5px;
  background-image: linear-gradient(white, white),
    radial-gradient(circle at top left, #4bc5e8, #9f6274);
  background-origin: border-box;
  background-clip: content-box, border-box;
}

.container {
  width: "100%";
  padding: 8px 16px;
}

.buttons {
  display: flex;
  gap: 8px;
  justify-content: center;
  margin-top: 8px;
}
</style>